import { AnswersEndpoints, answersFetch, answersFetchJson } from './answersApiClient';

let filterOptionsCache = null;

/**
 * Cached filter options for the Answers scope drawer.
 * @returns {Promise<Record<string, unknown>>}
 */
export function getFilterOptions() {
  if (!filterOptionsCache) {
    filterOptionsCache = answersFetch(AnswersEndpoints.FILTER_OPTIONS)
      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Filter options failed: ${response.status}`);
        }
        return response.json();
      })
      .catch((error) => {
        filterOptionsCache = null;
        throw error;
      });
  }
  return filterOptionsCache;
}

export function clearFilterOptionsCache() {
  filterOptionsCache = null;
}

/**
 * Count filings matching the current filter payload.
 * @param {Record<string, unknown>} filterPayload
 * @returns {Promise<{ matching_filings_count: number | null }>}
 */
export async function getFilterMatchCount(filterPayload) {
  return answersFetchJson(AnswersEndpoints.FILTER_MATCH_COUNT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(filterPayload),
  });
}
